export const MAX_IMAGE_SIZE = 10 * 1024 * 1024;
export const ACCEPT_IMAGE_FILE_TYPES = 'image/png,image/jpeg,image/jpg';
